import moment from 'moment';

import createModel, { prop } from './lib/create_model';

const CommentPanel = createModel({
  modelName: 'CommentPanel',
  properties: {
    lastOpenedAt: prop(String).default(''),
    selectedItemId: prop(String).default(null),
  },

  isOpen() {
    return !!this.lastOpenedAt;
  },

  open() {
    this.lastOpenedAt = moment().toISOString();
  },

  close() {
    this.lastOpenedAt = '';
  },

  selectItemId(itemId) {
    this.lastOpenedAt = moment().toISOString();
    this.selectedItemId = itemId;
  },

  clearItemId() {
    this.selectedItemId = null;
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default CommentPanel;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/comment_panel.js